
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

const TIMER_INITIAL_VALUE = 59;

const KEY_REGEX = "([A-Za-z0-9])";
const KEY_BACKSPACE = "Backspace";

@Component
export default class CodeInput extends Vue {
  @Prop({ type: Number, default: 6 }) readonly count!: number;
  @Prop({ type: Boolean, default: false }) readonly isError!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isTimer!: boolean;

  digits: string[] = [];

  componentKey = 0;

  setEmptyCode() {
    for (let i = 0; i < this.count; i++) {
      (this.digits[i] as string) = "";
    }
  }

  created() {
    this.setEmptyCode();
  }

  isDigitsFull = false;

  @Watch("isDigitsFull", { immediate: true })
  isDigitsFullChanged() {
    const code = this.digits.join("");

    if (!code) return;

    this.$emit("code-entered", code);
  }

  onEnterKeyDown(e: KeyboardEvent) {
    const index = this.digits.findIndex((digit) => !digit);

    if (index === -1) return;

    if (e.key.length === 1 && new RegExp(KEY_REGEX).test(e.key)) {
      this.digits[index] = e.key;

      this.componentKey += 1;
    } else if (e.key === KEY_BACKSPACE) {
      this.digits[index - 1] = "";

      this.componentKey += 1;
    }

    if (index === this.digits.length - 1) return (this.isDigitsFull = true);
  }

  beforeMount() {
    window.addEventListener("keydown", this.onEnterKeyDown);
  }

  beforeDestroy() {
    window.removeEventListener("keydown", this.onEnterKeyDown);

    this.stopTimer();
  }

  onChange(e: any) {
    e.preventDefault();

    const clipboardData = e.clipboardData;

    const pastedData = clipboardData.getData("Text");

    for (let i = 0; i < this.count; i++) {
      this.digits[i] = pastedData[i];

      this.componentKey += 1;
    }

    this.isDigitsFull = true;
  }

  get classes() {
    return {
      ["error"]: this.isError,
    };
  }

  clearError() {
    this.isDigitsFull = false;

    this.setEmptyCode();

    this.$emit("clear-error");
  }

  timer = TIMER_INITIAL_VALUE;

  timeout = null;

  get timerString() {
    return this.timer > 9 ? `00:${this.timer}` : `00:0${this.timer}`;
  }

  @Watch("isTimer", { immediate: true })
  isTimerChanged(value: boolean) {
    if (!value) return;

    this.timer = TIMER_INITIAL_VALUE;
  }

  @Watch("timer", { immediate: true })
  timerChanged(value: number) {
    if (value > 0) this.startTimer();

    if (value === 0) this.stopTimer();
  }

  startTimer() {
    this.timeout = setTimeout(() => {
      if (this.timer === 0) return this.stopTimer();

      this.timer -= 1;
    }, 1000);
  }

  stopTimer() {
    clearTimeout(this.timeout);

    this.$emit("update-timer", false);
  }
}
